import { render } from "./SubmissionMasterList.vue?vue&type=template&id=a5564f2a&scoped=true&ts=true"
import script from "./SubmissionMasterList.vue?vue&type=script&lang=ts"
export * from "./SubmissionMasterList.vue?vue&type=script&lang=ts"

import "./SubmissionMasterList.vue?vue&type=style&index=0&id=a5564f2a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5564f2a"]])

export default __exports__